import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { useState } from "react";
import { Menu as AntMenu } from "antd";
import classNames from "classnames";
import "./Menu.scss";
import "./MenuItem.scss";
import { styleClasses } from "../../helpers";
import { Icon } from "../../particles/Icon";
const CSS_PREFIX = `lav-components-menu`;
export const Menu = (_a) => {
    var { className = "", items, onDeselect, onSelect, multiple, selectedKeys = [] } = _a, antMenuProps = __rest(_a, ["className", "items", "onDeselect", "onSelect", "multiple", "selectedKeys"]);
    const [selectedKeysState, setSelectedKeysState] = useState(selectedKeys);
    const isIndividualItem = items.length === 1;
    return (_jsx("div", { className: isIndividualItem ? "" : CSS_PREFIX + "-wrapper", children: _jsx(AntMenu, Object.assign({}, antMenuProps, { className: classNames(styleClasses(CSS_PREFIX, {}), {
                [className]: !!className,
            }), selectedKeys: selectedKeysState, onSelect: (selectInfo) => {
                console.log("select", onSelect);
                const newSelectedKeys = multiple
                    ? [...selectedKeysState, selectInfo.key]
                    : [selectInfo.key];
                setSelectedKeysState(newSelectedKeys);
                onSelect === null || onSelect === void 0 ? void 0 : onSelect(Object.assign(Object.assign({}, selectInfo), { selectedKeys: newSelectedKeys }));
            }, onDeselect: (selectInfo) => {
                const newSelectedKeys = selectedKeysState.filter((key) => key !== selectInfo.key);
                setSelectedKeysState(newSelectedKeys);
                onDeselect === null || onDeselect === void 0 ? void 0 : onDeselect(Object.assign(Object.assign({}, selectInfo), { selectedKeys: newSelectedKeys }));
            }, children: items.map((item) => {
                const key = isIndividualItem ? "0" : String(item.key);
                return (_createElement(MenuItemInternal, Object.assign({}, item, { key: key, isIndividualItem: isIndividualItem, state: selectedKeysState.includes(key) ? "selected" : item.state })));
            }) })) }));
};
const MenuItemInternal = (_a) => {
    var { children, className = "", isIndividualItem, state, title, warning } = _a, antMenuItemProps = __rest(_a, ["children", "className", "isIndividualItem", "state", "title", "warning"]);
    const CSS_PREFIX = `lav-components-menu-item`;
    return (_jsxs(AntMenu.Item, Object.assign({ className: classNames(styleClasses(CSS_PREFIX, {
            isIndividualItem,
            state,
            title,
            warning,
        }), { [className]: !!className }) }, antMenuItemProps, { disabled: state === "disabled", danger: warning, children: [title ? (_jsxs("div", { className: CSS_PREFIX + "-inner", children: [_jsx("span", { className: CSS_PREFIX + "-title", children: title }), _jsx("span", { className: CSS_PREFIX + "-content", children: children })] })) : (children), !isIndividualItem && (_jsx(_Fragment, { children: state === "selected" ? (_jsx(Icon, { variant: "IconCheck", size: "extra-small", style: { marginLeft: 8 } })) : (_jsx("div", { style: { width: 24 } })) }))] })));
};
